export const INFOCLUB_DEFAULT_IMAGE = "/img/infoclub.png";

export const DEFAULT_INFOCLUB_SETTINGS = {
  infoclub_isactive: true,
  infoclub_title: "",
  infoclub_content: "",
  logo_club: "",
};

export function unwrapSettings(data) {
  if (Array.isArray(data)) return data[0] || null;
  return data || null;
}

export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeInfoClubPayload(settings) {
  return {
    ...settings,
    infoclub_isactive: !!settings?.infoclub_isactive,
    infoclub_title: String(settings?.infoclub_title || "").trim(),
    infoclub_content: String(settings?.infoclub_content || ""),
  };
}

export function validateInfoClubSettings(settings) {
  if (!settings?.infoclub_isactive) return "";

  if (!String(settings?.infoclub_title || "").trim()) {
    return "Le titre de la section Info Club est requis si la section est active.";
  }

  if (!stripHtml(settings?.infoclub_content || "")) {
    return "Le contenu de la section Info Club est requis si la section est active.";
  }

  return "";
}

export function calculateInfoClubStats(settings) {
  const isActive = !!settings?.infoclub_isactive;
  const hasTitle = !!String(settings?.infoclub_title || "").trim();
  const contentText = stripHtml(settings?.infoclub_content || "");
  const hasContent = !!contentText;
  const contentLength = contentText.length;

  let readiness = 0;

  if (isActive) readiness += 1;
  if (hasTitle) readiness += 1;
  if (hasContent) readiness += 1;

  return {
    isActive,
    hasTitle,
    hasContent,
    contentLength,
    readiness,
    readinessTotal: 3,
  };
}

export function buildInfoClubPreviewSettings(settings) {
  return {
    isActive: !!settings?.infoclub_isactive,
    title: settings?.infoclub_title || "Informations du club",
    content:
      settings?.infoclub_content ||
      "<p>Ajoutez ici vos informations importantes : horaires, actualités, rappels, événements ou consignes du club.</p>",
    image: INFOCLUB_DEFAULT_IMAGE,
  };
}